module.exports = __webpack_public_path__ + "pin-tuan/static/media/goods.f458b129.png";